// API-Basis: Ist REACT_APP_BACKEND_URL gesetzt (Preview/Entwicklung), wird
// diese Domain genutzt. Ist sie leer, läuft alles relativ über /api auf
// derselben Domain – die Seite funktioniert so unter jeder Domain ohne Neu-Build.
const BASE = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");
export const API = `${BASE}/api`;
